import React, { useContext } from "react";
import "./Item.css";
import { ItemDetailsData } from "../../../../Utils/DefinitionsInterfaces";
import { UserContext } from "../../CheckoutPage";
import { formatDateTime } from "../../../../Utils/TimeConverter";
import { convertDate } from "../../../../Utils/helper";

interface ItemPropsInterface {
  stateCheckoutItem: ItemDetailsData;
  isDefaultItem: boolean;
  cbRemoveProduct: (itemId: number) => void;
}

const calculateDiscount = (basePrice: number, sellingPrice: number): number => {
  const discount = ((basePrice - sellingPrice) / basePrice) * 100;
  return Math.round(discount); // Rounds to nearest integer
};

const Item = (props: ItemPropsInterface) => {
  const RoundComponent = () => {
    return (
      <div
        style={{
          height: "10px",
          width: "10px",
          backgroundColor: "rgba(154, 200, 254, 0.3)",
          border: "2px",
          borderColor: "rgba(35, 81, 136, 1)",
          borderRadius: 100,
          marginLeft: "10px",
          marginRight: "10px",
        }}
      ></div>
    );
  };
  const userContext = useContext(UserContext);
  const userDetails = userContext?.userDetails ?? {
    name: "",
    email: "",
    school: "",
    schoolID: 0,
    grade: 0,
    mobileNumber: "",
  };
  const individualReg = userContext?.individualReg ?? false;
  const backendSchool = userContext?.backendSchool ?? {
    schoolID: 0,
    schoolName: "",
    linkActive: false,
    city: "",
    state: "",
    individual_registration: false,
    examDate: "",
    isInternational: false,
    version_no: "V1",
    pg: "razorpay",
  };
  const examDate = userContext?.examDate ?? "";

  const examDateSplit = formatDateTime(backendSchool?.examDate).split(",");

  // Check if there's a discount
  const hasDiscount =
    props.stateCheckoutItem.base_price !==
    props.stateCheckoutItem.selling_price;

  return (
    <div className="item">
      <div className="wrap">
        <div className="item-title">{props.stateCheckoutItem.name}</div>
        <div
          style={{ display: "flex", justifyContent: "center", width: "100%" }}
        >
          <div
            style={{
              width: "60%",
              height: "2px",
              backgroundColor: "rgba(217, 217, 217, 1)",
              alignSelf: "center",
              marginRight: "10px",
            }}
          ></div>
          <div>
            {hasDiscount && (
              <span
                style={{
                  textDecoration: "line-through",
                  marginRight: "10px",
                }}
                className="text-wrapper-3"
              >
                {(backendSchool.isInternational ? "$" : "₹") +
                  props.stateCheckoutItem.base_price}
              </span>
            )}
            <span className="text-wrapper-3">
              {(backendSchool.isInternational ? "$" : "₹") +
                props.stateCheckoutItem.selling_price}
            </span>
            {hasDiscount && (
              <div
                style={{
                  fontSize: "14px",
                  color: "rgba(35, 81, 136, 1)",
                  fontWeight: "normal",
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "10px",
                }}
              >
                {calculateDiscount(
                  props.stateCheckoutItem.base_price,
                  props.stateCheckoutItem.selling_price
                )}
                % Off
              </div>
            )}
          </div>
        </div>
      </div>
      {individualReg ? (
        <div className="item-description">
          {individualReg ? (
            backendSchool.examDate &&
            backendSchool.examDate.length > 0 && (
              <div className="item-details-breakdown">
                <RoundComponent />
                {examDateSplit ? (
                  <div className="item-details-text">
                    Exam Scheduled for: {examDateSplit[0]}, <br />
                    {examDateSplit[1]} IST
                  </div>
                ) : (
                  <div className="item-details-text">
                    Please select a date for your exam
                  </div>
                )}
              </div>
            )
          ) : (
            <div className="item-details-breakdown">
              <RoundComponent />
              <div className="item-details-text">
                Exam Scheduled for: {convertDate(examDate)} IST
              </div>
            </div>
          )}

          <br />
          <div className="item-details-breakdown">
            <RoundComponent />
            <div className="item-details-text">
              Exam Mode: Proctored Online<br></br> (from your home)
            </div>
          </div>
          <br />
          <div className="item-details-breakdown item-details-breakdown-no-border">
            <RoundComponent />
            <div className="item-details-text">
              Note: Access to the NFO Student Hub (for your student
              credentials), will be sent to your registered mobile number and
              email once payment is confirmed.
            </div>
          </div>
        </div>
      ) : (
        <div className="item-description">
          <div className="item-details-breakdown">
            <RoundComponent />
            <div className="item-details-text">
              School: {backendSchool.schoolName}
            </div>
          </div>
          <br />
          {backendSchool.examDate && (
            <div className="item-details-breakdown">
              <RoundComponent />
              <div className="item-details-text">
                Exam Scheduled for: {convertDate(backendSchool.examDate)} IST
              </div>
            </div>
          )}
          <br />

          <div className="item-details-breakdown item-details-breakdown-no-border">
            <RoundComponent />
            <div className="item-details-text">
              Note: Access to the NFO Student Hub (for your student
              credentials), will be sent to your registered mobile number and
              email once payment is confirmed.
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Item;
